import { Appointment } from "../../../api/appointment.types";
import { PastAppointmentsMainAction } from "./appointments.past.types";

export const pastAppointmentsMainRequestAction = (params: { medic_user_id: number }): PastAppointmentsMainAction => ({ type: 'PAST_APPOINTMENTS_MAIN_REQUEST', params })

export const pastAppointmentsMainSuccessAction = (appointments: Appointment[]): PastAppointmentsMainAction => ({ type: 'PAST_APPOINTMENTS_MAIN_SUCCESS', params: appointments })

export const pastAppointmentsMainFailureAction = (error?: any): PastAppointmentsMainAction => ({ type: 'PAST_APPOINTMENTS_MAIN_FAILURE' })